import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledReschedulePopup } from 'components/Styled';
import { useHistory } from 'react-router-dom';

import Popup from 'components/common/Popup';

const ReschedulePopup = props => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleRescheduleClick = () => {
    const transaction = props.transactionRef;
    window.dataLayer.push({
      event: 'Click Start Pick Up Reschedule Button'
    });

    history.push(
      {
        pathname: `${process.env.PUBLIC_URL}/account/orders/reschedule-pickup/${transaction}`,
        state: {
          timeDate: props.timeDate
        }
      }
    );
  };

  const beforeReschedulePopup = [
    {
      content: (
        <StyledReschedulePopup>
          <div className="mini-title">
            {t('popup.reschedule_pickup_reminder.mini-title')}
          </div>
          <div className="title">
            {t('popup.reschedule_pickup_reminder.title')}
          </div>
          <div className="description">
            {t('popup.reschedule_pickup_reminder.before-body')}
          </div>
        </StyledReschedulePopup>
      )
    }
  ]

  const afterReschedulePopup = [
    {
      content: (
        <StyledReschedulePopup>
          <div className="mini-title">
            {t('popup.reschedule_pickup_reminder.mini-title')}
          </div>
          <div className="title">
            {t('popup.reschedule_pickup_reminder.title')}
          </div>
          <div className="description">
            {t('popup.reschedule_pickup_reminder.after-body')}
          </div>
        </StyledReschedulePopup>
      )
    }
  ]

  return (
    <>
      {props.isBefore ? <Popup popups={beforeReschedulePopup} type="reschedule" isRescheduled={false} toReschedule={handleRescheduleClick} action={props.action} /> :
        <Popup popups={afterReschedulePopup} type="reschedule" isRescheduled={true} action={props.action} />}
    </>
  )
}

export default ReschedulePopup;